import { render, staticRenderFns } from "./BsDatePicker.vue?vue&type=template&id=5f00ca10&"
import script from "./BsDatePicker.vue?vue&type=script&lang=js&"
export * from "./BsDatePicker.vue?vue&type=script&lang=js&"
import style0 from "./BsDatePicker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports